/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ProgressBar } from "components/progressBar/ProgressBar";
import {
  getDockedWidth,
  getHUDLeft,
  shouldAutoHideHud,
  isHudAnimationOut,
  applyAnimationClasses,
  animationInDuration,
  animationOutDuration,
  getAnimationType
} from "selectors/hudSelectors";
import { getTotalPages, getDocumentViewLeft, isPageByPageViewMode } from "selectors/documentSelectors";
import { getCurrentPageIndex } from "selectors/pageNumber";
import * as constants from "constants/constants";
import { getViewPortWidth } from "selectors/documentViewSelectors";
import { shouldShowScrubber } from "selectors/pagedViewState";
import { injectIntl } from "react-intl";

const isScrubberMode = stores => isPageByPageViewMode(stores);
const getBottomMargin = stores => (isScrubberMode(stores) ? 0 : !isHudAnimationOut(stores) ? constants.HUD_HEIGHT : 0);
const getLeft = stores => (isScrubberMode(stores) ? 0 : getHUDLeft(stores));
const getProgressBarWidth = stores =>
  isScrubberMode(stores) ? getViewPortWidth(stores) - constants.SCRUBBER_HEIGHT : parseInt(getDockedWidth(stores), 10);

const mapStoreToProps = (stores, ownProps) => ({
  left: getLeft(stores),
  isHudAutoHiding: shouldAutoHideHud(stores),
  applyAnimationClasses: applyAnimationClasses(stores),
  animationInDuration: animationInDuration(stores),
  animationOutDuration: animationOutDuration(stores),
  animationType: getAnimationType(stores),
  isHudAnimationOut: isHudAnimationOut(stores),
  progressBarWidth: getProgressBarWidth(stores),
  numOfPages: getTotalPages(stores),
  bottom: getBottomMargin(stores),
  popOverBottom: constants.PROGRESS_BAR_HEIGHT + constants.HUD_HEIGHT + 8, // 8px space between tooltip and progress bar
  pageIndex: getCurrentPageIndex(stores),
  pageWidth: getProgressBarWidth(stores) / getTotalPages(stores),
  onClick: pageNumber => {
    stores.pagedViewState.goToPage(pageNumber);
  },
  disableContextMenu: className => {
    stores.contextMenuStore.addClassNameToDisableContextMenuOn(className);
  },
  getDocumentViewLeft: getDocumentViewLeft(stores),
  scrubberMode: isScrubberMode(stores),
  shouldShowScrubber: shouldShowScrubber(stores)
});

const ProgressBarContainer = injectIntl(inject(mapStoreToProps)(ProgressBar));

export { ProgressBarContainer };
